<a [href]="href()" [ngClass]="getClasses()" [target]="getTarget()">{{ label() }}</a>
